<template>
	<div>
		<v-card
			color="white"
			flat
			tile
			class
			height="430"
			:max-width="!$vuetify.breakpoint.mdAndDown ? '80%' : '100%'"
			:width="!$vuetify.breakpoint.mdAndDown ? '80%' : '100%'"
		>
			<v-img height="210" :src="offer.imageurl">
				<div
					v-if="!isDatePast(offer.launchedat)"
					class="secondary px-2 py-1 white--text"
					style="position: absolute; top: 5px; right: 5px"
				>
					{{
						Math.abs(
							timeDifferenceInDays(new Date(offer.launchedat), new Date())
						)
					}}
					day{{
						Math.abs(
							timeDifferenceInDays(new Date(offer.launchedat), new Date())
						) > 1
							? "s"
							: ""
					}}
					to go!
				</div>
				<div
					v-if="false && offer.status"
					class="error lighten-1 px-2 py-1 white--text"
					style="position: absolute; top: 5px; right: 5px"
				>
					{{ offer.availableslots }}
					units left!
				</div>
				<div class="fill-height bottom-gradient"></div>
			</v-img>

			<div class="pt-4 text-left">
				<v-card
					flat
					color="transparent"
					class="text-h6 font-weight-bold black--text overflow-hidden"
					height="30"
				>
					{{ offer.packagename }}
				</v-card>
				<div class="secondary--text lighten-2 text-h6">
					{{ offer.roi }}% in {{ offer.duration }} month{{
						offer.duration > 1 ? "s" : ""
					}}
				</div>
				<div class>
					<span class="text-h6 font-weight-bold mr-1">
						{{ formattedAmount }}
					</span>
					<span>per unit</span>
				</div>
			</div>
			<div class="pb-4 pt-1">
				<div class="d-flex align-center" v-if="!isDatePast(offer.launchedat)">
					<div class="mr-2"><v-icon color="secondary">mdi-clock</v-icon></div>
					<div>Live on {{ formatDate(offer.launchedat) }}</div>
				</div>
			</div>

			<div class="d-flex justify-start pb-8">
				<v-btn
					depressed
					tile
					:disabled="!isAvailable"
					color="secondary"
					class="text-none px-5 py-5 mr-3"
					@click="togglePaymentMethodDialog(true)"
					>{{ offerStatus }}</v-btn
				>
				<v-btn
					tile
					depressed
					outlined
					color="primary"
					class="text-none px-5 py-5"
					@click="toggleInvestmentDrawer"
					>About</v-btn
				>
			</div>
		</v-card>
		<investment-dialog
			@openPaystack="paystackOpen"
			:paymentDialog="paymentDialog"
			:toggleInvestmentDialog="togglePaymentMethodDialog"
			:investment="offer"
			:isOnboarding="isOnboarding"
		/>
		<hm-paystack
			:isOpen="isPaystackOpen"
			:paystackCallback="paystackCallback"
			:paystackClose="paystackClose"
			:totalAmount="totalAmount"
			:reference="reference"
			:paymentChannel="selectedPaymentMethod"
		/>
	</div>
</template>

<script>
	import { formatMoney, formatDate } from "@/utils/helpers";
	import InvestmentDialog from "./InvestmentDialog";
	import HmPaystack from "./../HmPaystack";
	import { TransactionService } from "@/services/index.js";

	export default {
		components: { InvestmentDialog, HmPaystack },

		props: {
			offer: {
				type: Object,
			},
			isOnboarding: {
				type: Boolean,
				default: false,
			},
		},
		data() {
			return {
				formatDate,
				drawer: null,
				paymentDialog: null,
				isPaystackOpen: false,
				totalAmount: 0,
				reference: "",
				packageid: "",
				selectedPaymentMethod: "",
			};
		},
		computed: {
			formattedAmount() {
				// do not convert from kobo to naira for amounts
				return formatMoney(this.offer.amount ?? 0);
			},
			offerStatus() {
				let text = "Sold Out";

				if (this.offer.status && !this.isDatePast(this.offer.launchedat)) {
					text = "Coming Soon...";
				} else if (this.isAvailable) {
					text = "Invest";
				}
				return text;
			},
			isAvailable() {
				return this.offer.status && this.isDatePast(this.offer.launchedat);
			},
		},
		methods: {
			toggleInvestmentDrawer() {
				this.$store.commit("toggleDrawer", {
					type: "investments",
					value: true,
					entity: this.offer,
				});
			},
			isDatePast(date) {
				let selectedDate = new Date(date);
				var now = new Date();
				now.setHours(0, 0, 0, 0);

				return this.timeDifferenceInDays(selectedDate, now) >= 0;
			},
			timeDifferenceInDays(d1, d2) {
				d2.setHours(0, 0, 0, 0);

				var t2 = d2.getTime();
				var t1 = d1.getTime();

				return parseInt((t2 - t1) / (24 * 3600 * 1000));
			},
			togglePaymentMethodDialog(value) {
				this.paymentDialog = value;
			},
			async paystackCallback(res) {
				const { reference } = res;

				this.isPaying = true;
				try {
					const { message } = await TransactionService.verify(
						reference,
						this.packageid,
						"investments",
						"0"
					);

					this.$store.commit("openSnackbar", message);
				} catch (error) {
					this.isPaying = false;
				} finally {
					this.isPaying = false;
					this.isPaystackOpen = false;
					window.fbq("trackCustom", "Invested");
					this.$ua.trackEvent("Banner", "Click", "Invested!");
				}
			},
			paystackClose() {
				this.isPaystackOpen = false;
			},
			async paystackOpen(form) {
				try {
					this.selectedPaymentMethod = form.channel;
					this.packageid = form.packageid;

					const reference = await TransactionService.initiatePayment({
						entity: "investments",
						packageid: this.packageid,
						slots: form.units,
					});

					this.reference = reference.reference;

					this.isPaystackOpen = true;
					this.totalAmount = form.total;
				} catch (error) {}
			},
		},
	};
</script>
